export default "__VITE_ASSET__BmD7SHkf__"